import configure from "$src/core/styles/configure";
import config from "$src/flavors/hyview/flavor.config";

configure(config.theme);
